export default __webpack_public_path__ + "static/younis-4aaee994a62739b22376a2246d7fdf08.jpg";